import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import getEnvConfig from '../../../../../utils/config/env';
import { FeedProps, FeedResponseProps } from './feed.interface';

export const feedApi = createApi({
    reducerPath: 'feed',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Feed'],

    endpoints: builder => ({
        createFeed: builder.mutation<any, FeedProps>({
            query: payload => ({
                url: `/shops/feed/${payload.id}`,
                method: 'POST',
                body: { ...payload },
            }),
            transformResponse: (response: { data: any }) => {
                return response;
            },

            invalidatesTags: ['Feed'],
        }),
        createFileFeed: builder.mutation<any, any>({
            query: ({ id, body }) => ({
                url: `/shops/feed/${id}/upload`,
                method: 'POST',
                body: body,
            }),
            transformResponse: (response: { data: any }) => {
                return response;
            },

            invalidatesTags: ['Feed'],
        }),
        readFeed: builder.query<FeedResponseProps, number>({
            query: id => {
                return {
                    url: `/shops/feed/${id}`,
                };
            },
            transformResponse: (response: { data: FeedResponseProps }) => {
                return response.data;
            },
        }),
    }),
});

export const {
    useCreateFeedMutation,
    useLazyReadFeedQuery,
    useCreateFileFeedMutation,
} = feedApi;
